import React, {useState, useRef, useEffect, useCallback} from "react";
import { useScroll, useSpring, animated } from '@react-spring/web'
import { Navigate } from 'react-router-dom';
import './Mainmastet.css'
import Smartlog from '../logo.svg';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as IoIcons from 'react-icons/io'
import Ideapng from '../resorcesfiles/images/newidea.png'
import * as CiIcons from 'react-icons/ci'
import ProductFloat from "../pages/ProductFloat";
import axios from "axios";
import { SlMenu } from "react-icons/sl";


const Mainmastet = props => {
    const [goToalltribute, setgoToalltribute] = React.useState(false);
    const [goToHome, setgoToHome] = React.useState(false);
    const [goToMy, setgoToMy] = React.useState(false);
    const [activeButton, setActiveButton] = useState("");
    const [goToAddobituary, setgoToAddobituary] = useState(false);
    const [fromvalue, setfromvalue] = useState(0)
    const [tovalue, settovalue] = useState(0)
    const [transfrom, settransfrom] = useState(2)
    const [transto, settransto] = useState(1)
    const [goTocontact, setgoTocontact] = React.useState(false);
    const [goToaddlisting, setgoToaddlisting] = React.useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [hideComp, sethideComp] = React.useState(true);
    const [hoverProducts, sethoverProducts] = React.useState(false);    
    const [hoverSolutions, sethoverSolutions] = React.useState(false);    

    const timeoutRef = useRef(null);
    const [Sidemenu, setSidemenu] = React.useState(false);
    const [hoverContact, sethoverContact] = React.useState(false);    
    const [aboutUsDropdown, setAboutUsDropdown] = useState(false);
    const [ProductsDropdown, setProductsDropdown] = useState(false);
    const [SidemenuM, setSidemenuM] = React.useState(false);
    const [SolutionDropdown, setSolutionDropdown] = useState(false);


    useEffect(() => {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      //  console.log("Screen width " + window.innerWidth)
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);



    useEffect(() =>{
      console.log("Screen width2 " + window.innerWidth)

      if(window.innerWidth <= 800){
        sethideComp(false)
        setSidemenu(false)
      }else{
        sethideComp(true)
         setSidemenuM(false)
      }

    },[window.innerWidth,hideComp])

    const springs = useSpring({
      from: {
          x: fromvalue,
          trans: [0, 1, transfrom],
        },
        to: {
          x:tovalue,
          trans: [0, 1, transto],
        }, })
  
    const Firstanimation = async () =>{
      setSidemenuM(false)
    return  setSidemenu(false)
          if(Sidemenu){
            setfromvalue(0)
            settovalue(300)
            setTimeout(() =>{       
              setSidemenu(!Sidemenu)
            },500)
          }else{
            setSidemenu(!Sidemenu)
            setfromvalue(300)
            settovalue(0)
          }
      }

      if(goTocontact){
        return <Navigate to="/contactus" />
      }
    const handleButtonClick = async (buttonIndex) => {
      localStorage.setItem('sidebarnumber', `${buttonIndex}`)
      setActiveButton(buttonIndex);
    };


      const Openmy = () =>{
        setgoToMy(true)
      }

      const Openmenu = () =>{
        //Firstanimation()
      setSidemenu(!Sidemenu)
      }


      const emailAddress = 'stevobugus@gmail.com';
      const handleEmailClick = () => {
        const subject = 'Subject of the email'; // Optional: Add a subject
        const body = 'Hello, I would like to get in touch with you.'; // Optional: Add a pre-filled body
    
        const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(emailAddress)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
        window.open(mailtoLink, '_blank');
      };

      const encodedMessage = encodeURIComponent('Hi Stephen');
      const whatsappUrl = `https://wa.me/${'+254795861786'}?text=${encodedMessage}`;
    


      const showToast = (Messo) => {
        toast.success(`Cooming Soon`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000, 
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      };
    
      
      const toggleAboutUsDropdown = () => {
        setAboutUsDropdown(!aboutUsDropdown);
    };

    const toggleProductDropdown = () =>{
      setProductsDropdown(!ProductsDropdown)

    }

    const toggleSolutionDropdown = () =>{
      setSolutionDropdown(!SolutionDropdown)

    }


  
    return (
      <>   
       <ToastContainer /> 
        <div className="popup-boxa">
       
        <div className="staytop" style={{width:"100%",position:'absolute',top:0,borderTop:'none',borderTopColor:'transparent', minHeight:'65px',backgroundColor:'#a31b21'}}>       

            <div  className="gradblack" style={{color:'white',width:"100%",position:'relative',top:0,borderBottom:'solid',borderBottomColor:'gray',borderBottomWidth:0.2,minHeight:'130px',backgroundColor:"#a31b21",flexDirection:'column'}}>

            <div style={{flex:1,marginTop:3,marginLeft:'10%',display:'flex',flexDirection:'row'}}>
              <div style={{flex:1}}>
              {hideComp &&
              <table>
                <tr>
                  <td>
                  <div style={{width:'80px',height:'80px',borderRadius:'40px',backgroundColor:'white',justifyContent:'center',alignItems:"center",display:'flex',borderColor:'black',borderStyle:'groove',borderWidth:0.2}} >
                    <img src={Ideapng} style={{objectFit:'contain',width:'80%',height:'80%'}} />

                    </div>
                  </td>
                  <td>
                  <label style={{fontFamily:'fantasy',color:'white',marginRight:10,fontWeight:'bolder',fontSize:'16px'}}>ZIDITECH</label>
                  </td>
                </tr>
              </table>
            }
              {!hideComp &&
                    <div style={{display:'flex',flexWrap:'wrap'}}>

             <table>
                <tr>
                  <td>
                  <div style={{width:'80px',height:'80px',borderRadius:'40px',backgroundColor:'white',justifyContent:'center',alignItems:"center",display:'flex',borderColor:'black',borderStyle:'groove',borderWidth:0.2}} >
                    <img src={Ideapng} style={{objectFit:'contain',width:'80%',height:'80%'}} />

                    </div>
                  </td>
                  <td>
                  <label style={{fontFamily:'fantasy',color:'white',marginRight:10,fontWeight:'bolder',fontSize:'16px'}}>ZIDITECH</label>
                  </td>
                </tr>
              </table>

                            <h5 style={{fontFamily:'fantasy'}}>A CountryWide RFID Supplier Based in Nairobi | 12 Years of Innovation</h5>
                    </div>
      
              }

              </div>

              {hideComp && 
              (
                <div onClick={() =>{setSidemenu(true)}} style={{backgroundColor:'black',height:'40px',width:'40px',marginRight:10,justifyContent:'center',alignItems:'center',display:'flex'}}>
                <SlMenu onClick={() =>{setSidemenu(true)}} style={{color:'white',fontSize:'30px',backgroundColor:'black'}}/> 
                </div>  
              )
              }
              {!hideComp && 
              (
                <div onClick={() =>{setSidemenuM(true)}} style={{backgroundColor:'black',height:'40px',width:'40px',marginRight:10,justifyContent:'center',alignItems:'center',display:'flex'}}>
                <SlMenu onClick={() =>{setSidemenuM(true)}} style={{color:'white',fontSize:'30px',backgroundColor:'black'}}/> 
                </div>  
              )
              }





             </div>
             {hideComp &&          
              <div style={{position:'absolute',bottom:'1px',width:'80%',marginLeft:'10%',display:'flex',flexWrap:'wrap'}}>
                {/* <div onMouseEnter={() =>{clearTimeout(timeoutRef.current);sethoverProducts(true)}} 
                onMouseLeave={() =>{
                  
                  if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                  }
              
                  timeoutRef.current = setTimeout(() => {
                    sethoverProducts(false)
                  }, 300);
                }       } 
                  style={{marginRight:'10px'}}>
                  <table>
                    <tr>
                      <td>
                            <h3>Products</h3>
                      </td>
                      <td>
                        <IoIcons.IoIosArrowDown style={{color:'white',fontSize:'30px'}}/> 
                      </td>
                    </tr>
                  </table>
                </div> */}

              <Link to={`/`} style={{textDecoration:'none'}} >
                <div             
                style={{marginRight:'10px'}}>
                  <table>
                    <tr>
                      <td>
                            <h3 style={{color:"white"}}>HOME</h3>
                      </td>
                      <td>
                        <IoIcons.IoIosArrowDown style={{color:'white',fontSize:'30px'}}/> 
                      </td>
                    </tr>
                  </table>
                </div>
                </Link>


                {/* <div onMouseEnter={() =>{clearTimeout(timeoutRef.current);sethoverSolutions(true)}} 
                onMouseLeave={() =>{
                  
                  if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                  }
              
                  timeoutRef.current = setTimeout(() => {
                    sethoverSolutions(false)
                  }, 300);
                }       } 
                  style={{marginRight:'10px'}}>
                  <table>
                    <tr>
                      <td>
                            <h3>Solution</h3>
                      </td>
                      <td>
                        <IoIcons.IoIosArrowDown style={{color:'white',fontSize:'30px'}}/> 
                      </td>
                    </tr>
                  </table>

                </div> */}


                <Link to={`/ContactPage`} style={{textDecoration:'none'}} >
                <div style={{marginRight:'10px'}}>
                  <table>
                    <tr>
                      <td>
                            <h3 style={{color:"white"}}>CONTACT</h3>
                      </td>
                      <td>
                        <IoIcons.IoIosArrowDown style={{color:'white',fontSize:'30px'}}/> 
                      </td>
                    </tr>
                  </table>
                </div>
                </Link>

                   <Link to={`/AboutUs`} style={{textDecoration:'none'}} >
                   <div style={{marginRight:'10px'}}>
                  <table>
                    <tr>
                      <td>
                            <h3 style={{color:"white"}}>ABOUT US</h3>
                      </td>
                      <td>
                        <IoIcons.IoIosArrowDown style={{color:'white',fontSize:'30px'}}/> 
                      </td>
                    </tr>
                  </table>
                </div>
                   </Link>


                
           
              </div>
               }
              



            </div>
          

    
        </div>




        <div style={{flex:1,display:'flex',backgroundColor:"transparent",height:'100vh',overflow:'hidden'}}>
            <div style={{flex:1,backgroundColor:'transparent',height:'100vh',overflowY:'auto',position:'revert-layer',position:'relative'}}>
            <div style={{height:'130px'}}></div>                             
            {hoverProducts && 
            <div  onMouseEnter={() =>{clearTimeout(timeoutRef.current)}} 
                onMouseLeave={() =>{sethoverProducts(false)}}
                   style={{borderRadius:10,zIndex:2,position:'fixed',width:'100%'}}>
               <ProductFloat/>
               </div>                 
                 }

            {props.content}

            </div>
        </div>


        </div>


       
        {Sidemenu && (
            <div 
                style={{
                    flex: 1,
                    display: 'flex',
                    backgroundColor: "rgba(0,0,0,0.6)",
                    position: 'relative',
                    height: '100vh',
                    width: '100%',
                    position: 'absolute',
                    overflow: 'hidden'
                }}
            >
                <div onClick={Firstanimation} style={{ backgroundColor: 'transparent', flex: 1, height: '100%' }}></div>
                <animated.div className="gradmain" style={{ height: '100vh', overflowY: 'auto', width: 300, position: 'absolute', right: 0, ...springs, backgroundColor: '#a31b21' }}>
                    <div style={{ flex: 1, height: '100%' }}>
                        <div style={{ width: '100%', flexDirection: "column", backgroundColor: "#a31b21", height: '100%', display: 'flex' }}>
                            <div style={{ justifyContent: 'flex-end', alignItems: 'center', width: '100%', display: 'flex' }}>
                                <label onClick={Firstanimation} style={{ color: 'black', fontSize: '34px', fontWeight: 'bold', marginRight: 10, cursor: 'pointer' }}>X</label>
                            </div>

                            <Link onClick={() =>{setSidemenu(false)}} to={`/`}  style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}}> 
                                <button className={`button ${activeButton === 2 ? 'active' : ''}`}>
                                    Home 
                                </button>
                            </Link>
                            <div style={{height:'8px'}}></div>


                            <Link onClick={() =>{setSidemenu(false)}} to={`/AboutUs`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}}> 
                                <button style={{ marginRight: '20px' }} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                    About us
                                </button>
                            </Link>
                            <div style={{height:'8px'}}></div>


                            <Link onClick={() =>{setSidemenu(false)}} to={`/ContactPage`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2,flexDirection:'row',display:'flex',textDecoration:'none'}}> 
                                <button style={{ marginRight: '20px'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                    Contact
                                </button>
                            </Link>
                            <div style={{height:'8px'}}></div>

                            <Link onClick={toggleSolutionDropdown} className= {SolutionDropdown ? 'openedtab' : `linko`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:aboutUsDropdown ? 0 : 0.2,flexDirection:'row',display:'flex',textDecoration:'none'}}> 
                               <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'16px',marginRight:'2px'}}>Solutions</label>
                                  </div>

                                  <div style={{flex:1}}></div>
                                  <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'15px',marginRight:'2px'}}>▼</label>
                                  </div>

                            </Link>

                            {SolutionDropdown && (
                                <div style={{ marginLeft: 20,flexDirection:'column',display:'flex' }}>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProjectWarehouse`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier' }} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Warehouse
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProjectAsset`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Assets management
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={'/SolutionLibrary'}  style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Library
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={'./SolutionLinen'}  style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Linen
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={'/SolutionsCattle'}  style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Cattle management
                                        </button>
                                    </Link>

                                </div>
                            )}

                            <div style={{height:'8px'}}></div>


                            <Link onClick={toggleAboutUsDropdown} className= {aboutUsDropdown ? 'openedtab' : `linko`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:aboutUsDropdown ? 0 : 0.2,flexDirection:'row',display:'flex',textDecoration:'none'}}> 
                               <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'16px',marginRight:'2px'}}>Products</label>
                                  </div>

                                  <div style={{flex:1}}></div>
                                  <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'15px',marginRight:'2px'}}>▼</label>
                                  </div>

                            </Link>

                           
                            {aboutUsDropdown && (
                                <div style={{ marginLeft: 20,flexDirection:'column',display:'flex' }}>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/Productrfid`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier' }} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ RFID Readers
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProductsPrinter`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Printers
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProductsLabels`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Labels
                                        </button>
                                    </Link>

                                </div>
                            )}
                        </div>
                    </div>
                </animated.div>
            </div>
        )}

        {SidemenuM && (
            <div 
                style={{
                    flex: 1,
                    display: 'flex',
                    backgroundColor: "rgba(0,0,0,0.6)",
                    position: 'relative',
                    height: '100vh',
                    width: '100%',
                    position: 'absolute',
                    overflow: 'hidden',
                    flexDirection:'column'
                }}
            >
                <div onClick={Firstanimation} style={{ backgroundColor: 'transparent', flex: 1, height: '100%' }}></div>
                <animated.div className="gradmain" style={{ height: 'auto', overflowY: 'auto', width: '100%', position: 'absolute', right: 0, ...springs, backgroundColor: '#a31b21' }}>
                    <div style={{ flex: 1, height: '100%' }}>
                        <div style={{ width: '100%', flexDirection: "column", backgroundColor: "#a31b21", height: '100%', display: 'flex' }}>
                            <div style={{ justifyContent: 'flex-end', alignItems: 'center', width: '100%', display: 'flex' }}>
                                <label onClick={Firstanimation} style={{ color: 'black', fontSize: '34px', fontWeight: 'bold', marginRight: 10, cursor: 'pointer' }}>X</label>
                            </div>

                            <Link onClick={() =>{setSidemenu(false)}} to={`/`}  style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}}> 
                                <button className={`button ${activeButton === 2 ? 'active' : ''}`}>
                                    Home 
                                </button>
                            </Link>
                            <div style={{height:'8px'}}></div>

                            <Link onClick={() =>{setSidemenu(false)}} to={`/AboutUs`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}}> 
                                <button style={{ marginRight: '20px' }} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                    About us
                                </button>
                            </Link>
                            <div style={{height:'8px'}}></div>


                            <Link onClick={() =>{setSidemenu(false)}} to={`/ContactPage`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2,flexDirection:'row',display:'flex',textDecoration:'none'}}> 
                                <button style={{ marginRight: '20px'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                    Contact
                                </button>
                            </Link>
                            <div style={{height:'8px'}}></div>


                            <Link onClick={toggleSolutionDropdown} className= {SolutionDropdown ? 'openedtab' : `linko`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:aboutUsDropdown ? 0 : 0.2,flexDirection:'row',display:'flex',textDecoration:'none'}}> 
                            <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'16px',marginRight:'2px'}}>Solutions</label>
                                  </div>

                                  <div style={{flex:1}}></div>
                                  <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'15px',marginRight:'2px'}}>▼</label>
                                  </div>
                            </Link>

                            {SolutionDropdown && (
                                <div style={{ marginLeft: 20,flexDirection:'column',display:'flex' }}>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProjectWarehouse`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier' }} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Warehouse
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProjectAsset`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Assets management
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={'/SolutionLibrary'}  style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Library
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={'./SolutionLinen'}  style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Linen
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}}  to={'/SolutionsCattle'}  style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Cattle management
                                        </button>
                                    </Link>

                                </div>
                            )}


                            <div style={{height:'8px'}}></div>




                            <Link onClick={toggleAboutUsDropdown} className= {aboutUsDropdown ? 'openedtab' : `linko`} style={{borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:aboutUsDropdown ? 0 : 0.2,flexDirection:'row',display:'flex',textDecoration:'none'}}> 
                               <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'16px',marginRight:'2px'}}>Products</label>
                                  </div>

                                  <div style={{flex:1}}></div>
                                  <div style={{height:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
                                  <label style={{fontSize:'15px',marginRight:'2px'}}>▼</label>
                                  </div>

                            </Link>

                           
                            {aboutUsDropdown && (
                                <div style={{ marginLeft: 20,flexDirection:'column',display:'flex' }}>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/Productrfid`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier' }} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ RFID Readers
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProductsPrinter`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Printers
                                        </button>
                                    </Link>
                                    <Link onClick={() =>{setSidemenu(false)}} to={`/ProductsLabels`} style={{width:'100%',borderBottomColor:'silver',borderBottomStyle:'dotted',borderWidth:0.2}} > 
                                        <button style={{ marginRight: '20px',fontSize:'14px',fontFamily:'courier'}} className={`button ${activeButton === 4 ? 'active' : ''}`}>
                                        ▶ Labels
                                        </button>
                                    </Link>

                                </div>
                            )}
                                                        <div style={{height:'18px'}}></div>

                        </div>
                    </div>
                </animated.div>
            </div>
        )}



</>
      );
      };

export default Mainmastet;